export const VAT_RATE = 0.16;

export function calculateVat(amount) {
  return Math.round(Number(amount || 0) * VAT_RATE);
}

export function calculateTotalWithVat(amount) {
  return Number(amount || 0) + calculateVat(amount);
}
